/* ============================================================
pflanzenberater.js  →  Theme-Assets
Konfigurator-Logik: 5 Fragen → metafeldbasierte Empfehlung.

>>> ANPASSEN: Nur der CONFIG-Block unten muss ggf. an deine
tatsächlichen Metafeld-Werte angepasst werden.
Die Werte kommen aus #pb-products (Section, custom.*-Felder).
============================================================ */
(function () {
'use strict';

/* ---------- kleine SVG-Icons ---------- */
var ICON = {
use:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h18"/><path d="M6 7v13h12V7"/><path d="M9 11h6"/></svg>',
ruler: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20"/><path d="M9 5h3"/><path d="M9 9h3"/><path d="M9 13h3"/><path d="M9 17h3"/></svg>',
sun:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5L19 19M19 5l-1.5 1.5M6.5 17.5L5 19"/></svg>',
snow:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M4 7l16 10M20 7L4 17"/></svg>',
flower:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="9" r="3"/><path d="M12 12c0 4 0 7 0 10M9 6C7 5 5 6 5 8M15 6c2-1 4 0 4 2"/></svg>',
chevron:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>',
arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>',
back:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>',
leaf:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 4 13c0-5 5-9 16-9 0 9-4 14-9 14z"/><path d="M11 20c0-5 2-9 6-12"/></svg>'
};

/* ============================================================
CONFIG  —  HIER bei Bedarf anpassen
------------------------------------------------------------
- "match" = Liste von Begriffen, die im jeweiligen Metafeld
vorkommen müssen (Klein-/Großschreibung egal, Teiltreffer ok).
Trage hier die Begriffe ein, die WIRKLICH in deinen
custom.verwendung / custom.standort / custom.blutenfarbe stehen.
- Höhe + Winterhärte werden numerisch ausgewertet (Zahl wird aus
dem Feldwert extrahiert, z. B. "150-200 cm" -> 200, "-25 °C" -> -25).
============================================================ */
var CONFIG = {
heightField: 'wuchshohe',     // numerisch (cm)
hardyField:  'winterharte',   // numerisch (°C, negativ)

/* Bestseller werden bei passenden Antworten bevorzugt gelistet
und mit Badge markiert. Bonus greift NUR bei echter Passung
(mind. 1 Treffer) – nie gegen harte Kriterien wie die Höhe. */
bestseller: [
'rutenhirse-panicum-virgatum-northwind',
'riesenchinaschilf-miscanthus-japonicum-giganteus'
],
bestsellerBonus: 1,

questions: [
{
id: 'verwendung', field: 'verwendung', icon: ICON.use, weight: 3,
title: 'Wofür suchst du dein Gras?',
subtitle: 'Der Einsatzzweck im Garten',
options: [
{ label: 'Sichtschutz / Hecke', desc: 'Hoch & dicht für Privatsphäre', match: ['sichtschutz', 'hecke'] },
{ label: 'Kübel / Balkon & Terrasse', desc: 'Kompakt für Töpfe', match: ['kübel', 'kubel', 'balkon', 'terrasse', 'topf'] },
{ label: 'Solitär / Blickfang im Beet', desc: 'Einzelstellung als Hingucker', match: ['solitär', 'solitar', 'blickfang', 'beet'] },
{ label: 'Egal / weiß noch nicht', desc: 'Zeig mir die ganze Auswahl', match: [] }
]
},
{
id: 'hoehe', field: 'wuchshohe', icon: ICON.ruler, weight: 2, numeric: true,
title: 'Wie hoch darf es werden?',
subtitle: 'Ungefähre Wuchshöhe',
options: [
{ label: 'Kompakt – bis ca. 70 cm', desc: 'Niedrig, für vorne & Kübel', range: [0, 70] },
{ label: 'Mittel – ca. 70 bis 160 cm', desc: 'Vielseitig im Beet', range: [70, 160] },
{ label: 'Hoch – über 160 cm', desc: 'Großer Auftritt, Sichtschutz', range: [160, 9999] },
{ label: 'Egal', desc: 'Höhe ist mir nicht wichtig', range: null }
]
},
{
id: 'standort', field: 'standort', icon: ICON.sun, weight: 2,
title: 'Wie sonnig ist der Standort?',
subtitle: 'Lichtverhältnisse am Pflanzplatz',
options: [
{ label: 'Sonnig', desc: 'Volle Sonne den Großteil des Tages', match: ['sonne', 'sonnig', 'vollsonnig'] },
{ label: 'Halbschattig', desc: 'Zeitweise Schatten', match: ['halbschatten', 'halbschattig'] },
{ label: 'Egal', desc: 'Passt sich an', match: [] }
]
},
{
id: 'winterhaerte', field: 'winterharte', icon: ICON.snow, weight: 1, numeric: true,
title: 'Wie frosthart muss es sein?',
subtitle: 'Alle unsere Gräser sind winterhart – hier nur die Feinabstimmung',
options: [
{ label: 'Sehr frosthart (ca. -20 °C und kälter)', desc: 'Für raue Lagen', maxTemp: -20 },
{ label: 'Normal winterhart reicht', desc: 'Übliche Gartenlagen', maxTemp: null },
{ label: 'Egal', desc: 'Nicht wichtig', maxTemp: null }
]
},
{
id: 'blutenfarbe', field: 'blutenfarbe', icon: ICON.flower, weight: 1,
title: 'Welche Blütenfarbe gefällt dir?',
subtitle: 'Optional – für die Optik',
options: [
{ label: 'Silber / Weiß', desc: '', match: ['silber', 'weiß', 'weiss', 'creme'] },
{ label: 'Rosa / Rot', desc: '', match: ['rosa', 'rot', 'pink', 'purpur'] },
{ label: 'Braun / Beige', desc: '', match: ['braun', 'beige', 'bronze', 'kupfer'] },
{ label: 'Egal', desc: 'Farbe ist mir nicht wichtig', match: [] }
]
}
]
};

/* ---------- Helfer ---------- */
function norm(v) {
// Metafeldwert -> Array kleingeschriebener Tokens
if (v === null || v === undefined) return [];
if (Array.isArray(v)) return v.map(function (x) { return String(x).toLowerCase(); });
return String(v).toLowerCase().split(/[,;/|]+/).map(function (s) { return s.trim(); }).filter(Boolean);
}
function num(v) {
// erste Zahl (inkl. negativem Vorzeichen) aus dem Wert
if (v === null || v === undefined) return null;
if (typeof v === 'number') return v;
var m = String(v).replace(/\u2212/g, '-').match(/-?\d+(?:[.,]\d+)?/);
return m ? parseFloat(m[0].replace(',', '.')) : null;
}
function numMax(v) {
// größte Zahl (für Höhenbereiche wie "150-200"); Höhen sind positiv,
// daher KEIN Minus erlauben – sonst wird "150-200" als 150 und -200 gelesen.
if (v === null || v === undefined) return null;
if (typeof v === 'number') return v;
var all = String(v).match(/\d+(?:[.,]\d+)?/g);
if (!all) return null;
return Math.max.apply(null, all.map(function (s) { return parseFloat(s.replace(',', '.')); }));
}
function tokensMatch(fieldVal, terms) {
if (!terms || terms.length === 0) return null; // "egal" -> neutral
var toks = norm(fieldVal);
for (var i = 0; i < terms.length; i++) {
for (var j = 0; j < toks.length; j++) {
if (toks[j].indexOf(terms[i]) !== -1) return true;
}
}
return false;
}

/* ---------- App ---------- */
function init() {
var dataEl = document.getElementById('pb-products');
if (!dataEl) return;
var products = [];
try { products = JSON.parse(dataEl.textContent) || []; } catch (e) { products = []; }

var root = document.getElementById('pflanzenberater-app');
if (!root) {
root = document.createElement('div');
root.id = 'pflanzenberater-app';
dataEl.parentNode.insertBefore(root, dataEl.nextSibling);
}
var collectionUrl = dataEl.getAttribute('data-collection-url') ||
root.getAttribute('data-collection-url') || '/collections/graser';
var step = 0;
var answers = {};

function progressHtml() {
var total = CONFIG.questions.length;
var pct = Math.round((step / total) * 100);
return '<div class="pb-progress-wrap"><div class="pb-progress-info">' +
'<span>Frage ' + (step + 1) + ' von ' + total + '</span><span>' + pct + '%</span>' +
'</div><div class="pb-progress-bar"><div class="pb-progress-fill" style="width:' + pct + '%"></div></div></div>';
}

function renderQuestion() {
var q = CONFIG.questions[step];
var opts = q.options.map(function (opt, i) {
return '<button class="pb-option" data-opt="' + i + '"><div class="pb-option-inner"><div>' +
'<div class="pb-option-label">' + opt.label + '</div>' +
(opt.desc ? '<div class="pb-option-desc">' + opt.desc + '</div>' : '') +
'</div>' + ICON.chevron + '</div></button>';
}).join('');

var back = step > 0
? '<div class="pb-back-wrap"><button class="pb-back-btn" id="pb-back">' + ICON.back + ' Zurück</button></div>'
: '';

root.innerHTML = progressHtml() +
'<div class="pb-card"><div class="pb-question-header"><div class="pb-question-icon">' + q.icon + '</div>' +
'<div><div class="pb-question-title">' + q.title + '</div>' +
'<div class="pb-question-subtitle">' + q.subtitle + '</div></div></div>' +
'<div class="pb-options">' + opts + '</div>' + back + '</div>';

Array.prototype.forEach.call(root.querySelectorAll('.pb-option'), function (btn) {
btn.addEventListener('click', function () {
answers[q.id] = q.options[parseInt(btn.getAttribute('data-opt'), 10)];
step++;
if (step >= CONFIG.questions.length) renderResults();
else { renderQuestion(); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
});
});
var b = document.getElementById('pb-back');
if (b) b.addEventListener('click', function () { step--; renderQuestion(); });
}

function scoreProduct(p) {
var score = 0;
CONFIG.questions.forEach(function (q) {
var a = answers[q.id];
if (!a) return;

if (q.id === 'hoehe') {
if (!a.range) return;                 // egal
var h = numMax(p[CONFIG.heightField]);
if (h === null) return;               // kein Wert -> neutral
if (h >= a.range[0] && h <= a.range[1]) score += q.weight;
return;
}
if (q.id === 'winterhaerte') {
if (a.maxTemp === null) return;       // egal / normal
var t = num(p[CONFIG.hardyField]);
if (t === null) return;
if (t <= a.maxTemp) score += q.weight; // -25 <= -20  -> härter
return;
}
// Token-Felder (verwendung, standort, blutenfarbe)
var res = tokensMatch(p[q.field], a.match);
if (res === null) return;               // egal -> neutral
if (res === true) score += q.weight;
});
return score;
}

function renderResults() {
var scored = products.map(function (p) {
var s = scoreProduct(p);
var best = CONFIG.bestseller && CONFIG.bestseller.indexOf(p.handle) !== -1;
if (best && s > 0) s += CONFIG.bestsellerBonus; // Schub nur bei echter Passung
return { p: p, s: s, best: !!best };
});
// beste zuerst; verfügbare vor ausverkauften; dann Titel
scored.sort(function (a, b) {
if (b.s !== a.s) return b.s - a.s;
if (a.best !== b.best) return a.best ? -1 : 1; // Bestseller bei Gleichstand vorn
if (a.p.available !== b.p.available) return a.p.available ? -1 : 1;
return (a.p.title || '').localeCompare(b.p.title || '');
});

var positive = scored.filter(function (x) { return x.s > 0; });
var list = positive.length ? positive : scored; // Fallback: nie leer
list = list.slice(0, 12);

if (!list.length) {
root.innerHTML = '<div class="pb-empty">' + ICON.leaf +
'<p>Aktuell sind keine passenden Gräser hinterlegt.</p>' +
'<a class="pb-btn pb-btn-primary" href="' + collectionUrl + '">Alle Gräser ansehen ' + ICON.arrow + '</a></div>';
return;
}

var intro = positive.length
? 'Diese winterharten Gräser passen am besten zu deiner Auswahl:'
: 'Wir haben keine exakte Übereinstimmung gefunden – hier unsere Empfehlungen:';

var cards = list.map(function (x) {
var p = x.p;
var meta = [];
var h = p[CONFIG.heightField]; if (h) meta.push('<span>' + ICON.ruler + ' ' + h + '</span>');
var t = p[CONFIG.hardyField];  if (t) meta.push('<span>' + ICON.snow + ' ' + t + '</span>');
var sold = p.available ? '' : '<div class="pb-soldout-overlay"><span class="pb-soldout-tag">Ausverkauft</span></div>';
var bestBadge = x.best
? '<span style="position:absolute;top:10px;right:10px;z-index:2;background:#d97706;color:#fff;font-size:11px;font-weight:600;letter-spacing:.5px;padding:4px 10px;border-radius:99px;box-shadow:0 2px 6px rgba(0,0,0,.18)">Bestseller</span>'
: '';
var img = p.image
? '<img class="pb-product-img" src="' + p.image + '" alt="' + (p.title || '') + '" loading="lazy">'
: '';
return '<a class="pb-product' + (p.available ? '' : ' pb-soldout') + '" href="' + p.url + '">' +
'<div class="pb-product-img-wrap">' + img + sold +
'<span class="pb-product-badge gras">Gras</span>' + bestBadge + '</div>' +
'<div class="pb-product-info"><div class="pb-product-title">' + (p.title || '') + '</div>' +
(meta.length ? '<div class="pb-product-meta">' + meta.join('') + '</div>' : '') +
'<div class="pb-product-link"><span>' + (p.available ? 'Produkt ansehen' : 'Details ansehen') + '</span>' + ICON.arrow + '</div>' +
'</div></a>';
}).join('');

root.innerHTML =
'<div class="pb-results-header"><h2 class="pb-results-title">Deine Gräser-Empfehlung</h2><p>' + intro + '</p></div>' +
'<div class="pb-results-actions">' +
'<button class="pb-btn pb-btn-secondary" id="pb-restart">' + ICON.back + ' Neu starten</button>' +
'<a class="pb-btn pb-btn-primary" href="' + collectionUrl + '">Alle Gräser ansehen ' + ICON.arrow + '</a>' +
'</div><div class="pb-grid">' + cards + '</div>' +
'<div class="pb-results-footer">Familienbetrieb seit 1984 · Alle Pflanzen aus eigener Aufzucht · 3 Monate Anwuchsgarantie</div>';

var r = document.getElementById('pb-restart');
if (r) r.addEventListener('click', function () { step = 0; answers = {}; renderQuestion(); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
}

renderQuestion();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
})();
